"use client";

import S from "./index.module.scss";
import Pager from "./pager";
import { useNewsData } from "../../hooks/useNewsData";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/system/useStore";
import NewsCard from "./card";
import { scrollToTop } from "@/utils/helpers";
import { Spin } from "antd";

const NewsList = () => {
  const { news, newsList, newsLoading } = useNewsData();
  const { selectedFilters, setSelectedFilters } = useStore("news");

  const pageNumberChanger = (page: number, showMore: boolean) => {
    setSelectedFilters({ pageNumber: page, showMore });
    if (!showMore) scrollToTop();
  };

  return (
    <div className={S.wrapper}>
      {newsLoading ? (
        <Spin size="large" style={{ color: "black", margin: "200px 0" }} />
      ) : (
        <div className={S.borderWrap}>
          <div className={S.grid}>
            {newsList.map(item => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>
        </div>
      )}
      {news && (
        <Pager
          activePageNumber={selectedFilters.pageNumber || 1}
          total={news.total}
          activePageSize={6}
          onPageChangeHandler={page => pageNumberChanger(page, false)}
          onShowMoreChangeHandler={page => pageNumberChanger(page, true)}
        />
      )}
    </div>
  );
};

export default observer(NewsList);
